define('views/savings/edit',[
    'views/_base/baseview',
    'text!views/savings/edit.html',
    'views/shared/button/button',
    'views/shared/alerts/alert',
    'views/shared/modal/modal_modern'
], function (BaseView, Template, ButtonComponent, AlertModalView, Modal){
    'use strict';

    var target_amount = null;

    return BaseView.extend({
        id      : 'savings-edit-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'keyup .js-savings-target-amt-input' : 'handleKeyupNumberMODAL',
            'change .js-savings-target-amt-input' : 'handleBlurNumberMODAL',
            'click .js-savings-edit-delete-btn': 'checkBalanceMODAL',
            'click .js-savings-edit-save-btn'  : 'editSavingMODAL',
            'click .js-savings-edit-cancel-btn': 'closeMODAL',
            'click #pf-modal-close-btn'  : 'closeMODAL'
        },
        initialize: function(options){
            options = options || {};

            this.data = options.data;

            this.alert_modal = null;

            target_amount = (this.data) ? this.data.target_amount : null;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){
                that.addEditSavingButton();
                that.addDeleteAlertButton();
            },300);

            return this;
        },

        loadData: function(){},

        addEditSavingButton: function(){

            this.edit_saving_button = new ButtonComponent({
                // General
                elementName        : '.js-edit-savings-button-container',
                calling_view       : this,
                // Transactional
                is_transaction     : false,
                // Default
                btn_label          : pf.getContent('savings_and_goals.content.edit.button.save.label'),
                btn_callback       : this.editSavingMODAL,
                btn_retry_callback : this.editSavingMODAL,
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : pf.getContent('savings_and_goals.content.edit.button.save.cancel.label'),
                btn_cancel_callback: this.cancelEditSavingMODAL,
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : pf.getContent('savings_and_goals.content.edit.button.save.success.label'),
                btn_success_message: pf.getContent('savings_and_goals.content.edit.button.save.success.message'),
                btn_success_callback: this.editSavingSuccessMODAL,
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : pf.getContent('savings_and_goals.content.edit.button.save.error.label'),
                btn_error_cancel_label: pf.getContent('savings_and_goals.content.edit.button.save.cancel.label'),
                btn_error_message  : pf.getContent('savings_and_goals.content.edit.button.save.error.message'),
                btn_error_callback : this.canceledOnError
            });

        },

        cancelEditSavingMODAL: function(that){
            var that = (that) ? that : this;

            that.closeMODAL();
        },

        editSavingSuccessMODAL: function(resetButtons, that){
            var that = (that) ? that : this;

            if(resetButtons.name){
                that.edit_saving_button[resetButtons.name]();
            } else {
                resetButtons(that.edit_saving_button);
            }

            if(that.parent_view){
                that.parent_view.loadData();
                that.closeMODAL();
            } else {
                window.location.reload();
            }

        },

        canceledOnError: function(that){},

        editSavingMODAL: function(processComplete, that){
            var that = (that) ? that : this,
                account = that.data,
                name = $('.js-savings-name-input'),
                new_name = (name.val() != '') ? true : false,
                name_feedback = $('.js-savings-name-input-feedback'),
                name_valid = (new_name) ? that.validateNameMODAL(name,name_feedback) : true;

            if(!name_valid){

                if(processComplete.name){
                    that.edit_saving_button[processComplete.name](false);
                } else {
                    processComplete(false, that.edit_saving_button);
                }
                
                return false;
            }

            if(!new_name){
                var account_name = $('.js-savings-name-input').attr('placeholder');
            } else {
                var account_name = name.val();
            }

            if(!target_amount && target_amount != 0){
                var target = $('.js-savings-target-amt-input').attr('placeholder');
                target_amount = (Number(target) == 0) ? null : Number(target.slice(target.indexOf('$')+1));
            }


            var data = {
                account_name : _.escape(account_name),
                target_amount: target_amount
            };
       
            $.ajax({
                url : pf.url + '/Accounts/V2/' + account.account_id,
                type: 'PUT',
                data: JSON.stringify(data),
                processData: false,
                contentType: false,
                success    : function(response, status){

                    if(processComplete.name){
                        that.edit_saving_button[processComplete.name](true);
                    } else {
                        processComplete(true, that.edit_saving_button);
                    }

                },
                error: function(response, status, error){

                    if(processComplete.name){
                        that.edit_saving_button[processComplete.name](false);
                    } else {
                        processComplete(false, that.edit_saving_button);
                    }

                }
            });

        },

        addDeleteAlertButton: function(){
            var that = this;

            this.alert_modal_view = new AlertModalView({
                // General
                calling_view       : this,
                parent_view        : this,
                alert_type         : 1,
                // Transactional
                is_transaction     : false,
                // Content
                alert_header       : pf.getContent('savings_and_goals.content.edit.header'),
                alert_message      : pf.getContent('savings_and_goals.content.edit.message'),
                // Default
                btn_label          : pf.getContent('savings_and_goals.content.edit.button.delete.label'),
                btn_color          : 'red',
                btn_callback       : function(){
                    that.checkBalanceMODAL();
                },
                btn_retry_callback : function(){
                    that.checkBalanceMODAL();
                },
                // Confirm
                btn_confirm        : false,
                // Cancel
                btn_cancel         : true,
                btn_cancel_label   : pf.getContent('savings_and_goals.content.edit.button.delete.cancel.label'),
                btn_cancel_callback: function(){
                    that.cancelDeleteSavingMODAL();
                },
                // Success
                btn_success        : true,
                btn_success_delay  : 700,
                btn_success_label  : pf.getContent('savings_and_goals.content.edit.button.delete.success.label'),
                btn_success_message: pf.getContent('savings_and_goals.content.edit.button.delete.success.message'),
                btn_success_callback: function(){
                    that.deleteSavingSuccess();
                },
                // Error
                btn_error          : true,
                btn_error_delay    : 700,
                btn_error_label    : pf.getContent('savings_and_goals.content.edit.button.delete.error.label'),
                btn_error_cancel_label: 'Cancel',
                btn_error_message  : pf.getContent('savings_and_goals.content.edit.button.delete.error.message'),
                btn_error_callback : function(){
                    that.canceledDeleteSavingOnError();
                }
            });

        },

        cancelDeleteSavingMODAL: function(that){
            // console.log('cancelDeleteSavingMODAL', that);
            var that = (that) ? that.alert_modal_view.parent_view : this.alert_modal_view.parent_view;
            
            that.alert_modal.$el.fadeOut(function(){
                that.alert_modal.$el.remove();
            });
        },

        deleteSavingSuccess: function(resetButtons, that){
            var that = (that) ? that : this,
                resetButtons = (resetButtons) ? resetButtons : function(){};
            
            that.closeMODAL();

            if(resetButtons.name){
                that.alert_modal_view[resetButtons.name]();
            } else {
                resetButtons(that.alert_modal_view);
            }

            pf.navigate('#savings');

            setTimeout(function(){
                that.closeMODAL();

                pf.navigate('savings');
            }, 700);
            
        },

        canceledDeleteSavingOnError: function(that){
            // console.log('canceledDeleteSavingOnError');
        },

        checkBalanceMODAL: function(processComplete, that){
            if(processComplete && processComplete.preventDefault){ processComplete.stopPropagation(); processComplete.preventDefault(); }
            
            var that = (that) ? that : this,
                account = this.calling_view.data;

            $.ajax({
                type   : 'PUT',
                url    : pf.accountsURL + '/' + account.account_id + '/GetBalance',
                async  : false,
                contentType: 'application/json',
                success: function(response){

                    if(response){

                        that.calling_view.alert_modal_view.updateAlertHeader(pf.getContent('savings_and_goals.content.edit.remove.header'));
                        that.calling_view.alert_modal_view.updateAlertMessage(pf.getContent('savings_and_goals.content.edit.remove.message').replace('{{account_name}}', account.account_name));

                        that.calling_view.alert_modal_view.showProcessingState(false);
                        that.calling_view.alert_modal_view.updateBtnLabel(pf.getContent('savings_and_goals.content.edit.button.delete.success.label'));
                        that.calling_view.alert_modal_view.updateBtnLabelColor('blue');
                        that.calling_view.alert_modal_view.updateBtnCallback(function(){
                            that.cancelDeleteSavingMODAL(that.calling_view);
                        });
                        that.calling_view.alert_modal_view.updateBtnRetryCallback(function(){
                            that.cancelDeleteSavingMODAL(that.calling_view);
                        });

                        that.calling_view.alert_modal_view.parent_view = that;
                        
                        that.alert_modal = new Modal({
                            show        : true,
                            content     : that.calling_view.alert_modal_view.$el.html(),
                            calling_view: that.calling_view.alert_modal_view
                        });

                    } else {

                        // console.log('Success GetBalance',that);

                        that.calling_view.alert_modal_view.updateAlertHeader(pf.getContent('savings_and_goals.content.edit.remove.question').replace('{{account_name}}', account.account_name));
                        // that.calling_view.alert_modal_view.updateAlertMessage('The saving goal is successfully deleted');

                        that.calling_view.alert_modal_view.btn_callback = function(processComplete){
                            that.deleteAccountMODAL(processComplete, account, that.calling_view);
                        };
                        that.calling_view.alert_modal_view.btn_retry_callback = function(processComplete){
                            that.deleteAccountMODAL(processComplete, account, that.calling_view);
                        };

                        that.alert_modal = new Modal({
                            show        : true,
                            content     : that.calling_view.alert_modal_view.$el.html(),
                            calling_view: that.calling_view.alert_modal_view
                        });

                    }

                }
            });
        },

        deleteAccountMODAL: function(processComplete, account, that){

            $.ajax({
                type : 'PUT',
                url  : pf.accountsURL + '/' + account.account_id + '/0/UpdAccounts',
                async: false,
                contentType: 'application/json',
                success    : function(response){

                    if(response.Success){

                        if(processComplete.name){
                            that.alert_modal_view[processComplete.name](true);
                        } else {
                            processComplete(true, that.alert_modal_view);
                        }
                        
                    } else {

                        if(processComplete.name){
                            that.alert_modal_view[processComplete.name](false);
                        } else {
                            processComplete(false, that.alert_modal_view);
                        }

                    }

                },
                error: function(err){
                    // console.log('deleteAccountMODAL',err);

                    if(processComplete.name){
                        that.alert_modal_view[processComplete.name](false);
                    } else {
                        processComplete(false, that.alert_modal_view);
                    }
                }
            });

        },

        validateNameMODAL: function(item, item_feedback){
            var isValid = true;

            // validate first name
            if(item.val() == "" || !item.val() || !(item.val().length >= 2)){
                isValid = false;
            }
            // if either first or last are invalid
            if(isValid){
                item_feedback.hide();
                return true;
            } else {
                item_feedback.html('Enter at least 2 characters');
                item_feedback.show();
                return false;
            }
        },

        handleKeyupNumberMODAL: function(e){
            var data = keyupCurrencyHandling(e);
            
            $(e.target).val(data.string);

            target_amount = Number(data.number);

            // console.log('handleBlurNumberMODAL',target_amount);
        },

        handleBlurNumberMODAL: function(e){
            var data = blurCurrencyHandling(e);
            
            $(e.target).val(data.string);

            target_amount = Number(data.number);

            // console.log('handleBlurNumberMODAL',target_amount);
        },

        closeMODAL: function(){
            $('#pf-modal-modern').last().fadeOut(function(){
                $('#pf-modal-modern').last().remove();
            });
        },

        close: function(){}
    });
});

